import { render, staticRenderFns } from "./schoolAdd.vue?vue&type=template&id=60f49638"
import script from "./schoolAdd.vue?vue&type=script&lang=js"
export * from "./schoolAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f49638')) {
      api.createRecord('60f49638', component.options)
    } else {
      api.reload('60f49638', component.options)
    }
    module.hot.accept("./schoolAdd.vue?vue&type=template&id=60f49638", function () {
      api.rerender('60f49638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/schoolAdd.vue"
export default component.exports